import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _set from "lodash/set";
import _merge from "lodash/merge";
import _get from "lodash/get";
import _cloneDeep from "lodash/cloneDeep";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import camelcaseKeys from 'camelcase-keys';
import { createAction } from 'redux-act';
import { getLogger } from '@nerdwallet/logging';
import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { mapKeysDeep } from '@nerdwallet/utilities';
import { TU_AUTHENTICATION_STATUS_PROFILE_FIELD_MAP, TU_CREDIT_REPORT_PROFILE_FIELD_MAP } from "../features/credit-score/constants";
import { AUTHENTICATE_CREDIT_PROFILE_MUTATION, AUTHENTICATE_CREDIT_PROFILE_QUESTIONS_MUTATION, CREATE_TRUST_SESSION_ID_MUTATION, DEACTIVATE_CREDIT_PROFILE_MUTATION, ENROLL_CREDIT_PROFILE_MUTATION, INITIALIZE_CREDIT_PROFILE_MUTATION, IS_TU_DUPLICATE_EMAIL_QUERY, TU_ENROLL_FAILED_QUERY, IS_TU_RATE_LIMITED_QUERY, REFRESH_CREDIT_PROFILE_MUTATION } from "../features/credit-score/queries/auth";
import { fetchFinancialData, transformFinancialDataProfileToLegacyDataShape } from "../utils/financial-data";
import { updateIdentityProfile } from "./profiles";
import { createAsyncAction, parseGraphQLErrorDetails } from "./utils";
import getWebAppleTokenInfo from "./web-apple-sdk/web-apple-sdk";
import { getCookie } from "../utils/cookies";
var logger = getLogger('auth');

var getProfiles = function getProfiles(_ref) {
  var _merge2;

  var state = _ref.state,
      profiles = _ref.profiles,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      registerImpressionId = _ref.registerImpressionId;
  var globalProfile = {
    first_name: firstName,
    last_name: lastName
  };

  var regTrackingProfile = _cloneDeep(_get(state, 'identity.tracking.trk', {}));

  if (registerImpressionId) {
    regTrackingProfile.page_impression_id = registerImpressionId;
  }

  return _merge({}, (_merge2 = {}, _defineProperty(_merge2, NwApiSDK.IDENTITY_PROFILES.GLOBAL_PROFILE, globalProfile), _defineProperty(_merge2, NwApiSDK.IDENTITY_PROFILES.REGISTRATION_TRACKING_PROFILE, regTrackingProfile), _merge2), profiles);
};

var handleCreateTUCustomerError = function handleCreateTUCustomerError(err, apolloClient) {
  var _err$graphQLErrors;

  var graphQLError = (_err$graphQLErrors = err.graphQLErrors) === null || _err$graphQLErrors === void 0 ? void 0 : _err$graphQLErrors[0];

  if (!graphQLError) {
    return;
  }

  var _parseGraphQLErrorDet = parseGraphQLErrorDetails(graphQLError),
      internalMessage = _parseGraphQLErrorDet.internalMessage,
      responseData = _parseGraphQLErrorDet.responseData;

  var _ref2 = responseData !== null && responseData !== void 0 ? responseData : {},
      _ref2$blocking_emails = _ref2.blocking_emails,
      blockingEmails = _ref2$blocking_emails === void 0 ? [] : _ref2$blocking_emails;

  switch (internalMessage) {
    case 'User has attempted authentication too many times':
      apolloClient.writeQuery({
        query: IS_TU_RATE_LIMITED_QUERY,
        data: {
          _isTuRateLimited: true
        }
      });
      break;

    case 'Active TU Enrollment already exists for SSN':
      if (blockingEmails.length > 0) {
        apolloClient.writeQuery({
          query: IS_TU_DUPLICATE_EMAIL_QUERY,
          data: {
            _isTuDuplicateEmail: true,
            _tuDuplicateEmail: blockingEmails === null || blockingEmails === void 0 ? void 0 : blockingEmails[0]
          }
        });
      }

      break;

    default:
      break;
  }
};
/**
 * Gets a CSRF token from identity. Typically you shouldn't have to do this and it will happen
 * automatically unless your app is only rendered client-side (e.g. the auth dialog).
 * @return {Promise}
 */


export var initClientCSRF = createAsyncAction('initClientCSRF', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.initCsrfSessionFromClient();
    }
  };
}); // *** Sign in

export var signin = createAsyncAction('signin', function (email, password, rememberMe, app, enableHeadersAndMeta) {
  return {
    meta: {
      rememberMe: rememberMe,
      enableHeadersAndMeta: enableHeadersAndMeta
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.login(app || opts.identityApp, email, password, opts.identityProfilesToInclude, rememberMe, undefined, enableHeadersAndMeta);
    },
    parseFail: function parseFail(resp) {
      if (_get(resp, 'resp.statusCode') === 429) {
        return {
          isBlocked: true
        };
      }

      return {
        signinAttemptsRemaining: _get(resp, 'data.error.data.attempts_remaining')
      };
    }
  };
});
export var generateOneTimeCookieIdTransferToken = createAsyncAction('generateOneTimeCookieIdTransferToken', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.generateOneTimeCookieIdTransferToken();
    }
  };
});
export var generateOneTimeLoginToken = createAsyncAction('generateOneTimeLoginToken', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.generateOneTimeLoginToken();
    }
  };
});
export var signinWithOneTimeToken = createAsyncAction('signinWithOneTimeToken', function (token, deviceID, rememberMe, serverRequest, app, enableHeadersAndMeta) {
  return {
    meta: {
      enableHeadersAndMeta: enableHeadersAndMeta
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.loginViaOneTimeToken(app || opts.identityApp, token, deviceID, opts.identityProfilesToInclude, rememberMe, serverRequest, enableHeadersAndMeta);
    },
    parseFail: function parseFail(resp) {
      if (_get(resp, 'resp.statusCode') === 429) {
        return {
          isBlocked: true
        };
      }

      return {
        signinAttemptsRemaining: _get(resp, 'data.error.data.attempts_remaining')
      };
    }
  };
});
/**
 * For use on the mobile app to differentiate between manual signout and fingerprint cancel /
 * auto signout after 401
 */

export var softSignout = createAction('softSignout');
/**
 * For use only on the server to update the store with the currently logged in identity. Note: for
 * this to work you need to be using `attachReactFluxIntegrationMiddlewares` server middleware from
 * nw-api-sdk. See the integration steps docs for more information.
 */

export var preloadIdentity = createAction('preloadIdentity');
export var register = createAsyncAction('register', function (email, password, firstName, lastName) {
  var profiles = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var app = arguments.length > 5 ? arguments[5] : undefined;
  var enableHeadersAndMeta = arguments.length > 6 ? arguments[6] : undefined;
  return {
    makeRequest: function makeRequest(state, opts) {
      var mergedProfiles = getProfiles({
        profiles: profiles,
        firstName: firstName,
        lastName: lastName,
        state: state,
        registerImpressionId: _get(state, 'identity.tracking.registerImpressionId')
      });
      return opts.IdentitySDK.register(app || opts.identityApp, email, password, mergedProfiles, undefined, opts.IdentitySDK.EMAIL_VERIFICATION_URLS.MY_NERDWALLET, opts.identityProfilesToInclude, undefined, enableHeadersAndMeta);
    },
    meta: {
      enableHeadersAndMeta: enableHeadersAndMeta
    }
  };
}); // Google OAuth signin based on window.gapi

var getGoogleOAuthTokenFromGapi = function getGoogleOAuthTokenFromGapi() {
  // google api not loaded so we can't make a request: fail
  if (typeof window === 'undefined' || typeof _get(window, 'gapi.auth2.getAuthInstance') !== 'function') {
    return Promise.reject();
  } // google's signin method returns a non-standard promise without a .catch() method which breaks middleware
  // wrapping it in another promise to fix this


  return new Promise(function (resolve, reject) {
    var authInstance = window.gapi.auth2.getAuthInstance();
    authInstance.signIn({
      prompt: 'select_account'
    }).then(function () {
      var googleOauthToken = authInstance.currentUser.get().getAuthResponse().id_token;
      resolve(googleOauthToken);
    }, reject);
  });
};

export var authenticateWithCorpIdp = createAsyncAction('authenticateWithCorpIdp', function () {
  var authType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'signin';
  var rememberMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var accessToken = arguments.length > 2 ? arguments[2] : undefined;
  var clientId = arguments.length > 3 ? arguments[3] : undefined;
  var app = arguments.length > 4 ? arguments[4] : undefined;
  var enableHeadersAndMeta = arguments.length > 5 ? arguments[5] : undefined;
  return {
    meta: {
      accessToken: accessToken,
      authType: authType,
      enableHeadersAndMeta: enableHeadersAndMeta,
      rememberMe: rememberMe,
      usingPassword: false,
      usingExistingToken: false
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.loginViaCorpIdp(app || opts.identityApp, accessToken, clientId, false, // rememberMe
      undefined, // serverRequest
      true // enableHeadersAndMeta
      );
    }
  };
});
export var authenticateWithGoogle = createAsyncAction('authenticateWithGoogle', function () {
  var authType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'signin';
  var rememberMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var password = arguments.length > 2 ? arguments[2] : undefined;
  var app = arguments.length > 3 ? arguments[3] : undefined;
  var profiles = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var token = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var enableHeadersAndMeta = arguments.length > 6 ? arguments[6] : undefined;
  var identityProfilesToInclude = arguments.length > 7 ? arguments[7] : undefined;
  var callerContext = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  return {
    meta: {
      authType: authType,
      rememberMe: rememberMe,
      usingPassword: !!password,
      usingExistingToken: !!token,
      enableHeadersAndMeta: enableHeadersAndMeta
    },
    makeRequest: function makeRequest(state, opts) {
      var mergedProfiles = getProfiles({
        profiles: profiles,
        state: state,
        registerImpressionId: _get(state, 'identity.tracking.registerImpressionId')
      }); // by default use getGoogleOAuthTokenFromGapi to get the token

      var getGoogleOAuthToken = getGoogleOAuthTokenFromGapi; // if a token is explicitly passed use that. Resolved promise here so interface matches getGoogleOAuthTokenFromGapi

      if (token) getGoogleOAuthToken = function getGoogleOAuthToken() {
        return Promise.resolve(token);
      }; // or if there is an option `getGoogleOAuthToken` use that (typically used by mobile app).
      else if (opts.getGoogleOAuthToken) {
        getGoogleOAuthToken = opts.getGoogleOAuthToken;
      }
      return getGoogleOAuthToken({
        usingPassword: !!password,
        callerContext: callerContext
      }).then(function (googleOAuthToken) {
        return new Promise(function (resolve, reject) {
          if (!googleOAuthToken) {
            reject(new Error('no_oauth_token_received'));
            return;
          }

          opts.IdentitySDK.loginViaGoogle(app || opts.identityApp, googleOAuthToken, identityProfilesToInclude || opts.identityProfilesToInclude, mergedProfiles, rememberMe, password, undefined, enableHeadersAndMeta).then(resolve).catch(function (err) {
            return reject(err);
          });
        });
      });
    }
  };
});
export var authenticateWithApple = createAsyncAction('authenticateWithApple', function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$authType = _ref3.authType,
      authType = _ref3$authType === void 0 ? 'signin' : _ref3$authType,
      _ref3$rememberMe = _ref3.rememberMe,
      rememberMe = _ref3$rememberMe === void 0 ? true : _ref3$rememberMe,
      password = _ref3.password,
      app = _ref3.app,
      profiles = _ref3.profiles,
      enableHeadersAndMeta = _ref3.enableHeadersAndMeta;

  return {
    meta: {
      authType: authType,
      rememberMe: rememberMe,
      enableHeadersAndMeta: enableHeadersAndMeta,
      usingPassword: !!password
    },
    makeRequest: function makeRequest(state, opts) {
      var mergedProfiles = getProfiles({
        profiles: profiles,
        state: state,
        registerImpressionId: _get(state, 'identity.tracking.registerImpressionId')
      });
      var getAppleTokenInfo = opts.getAppleTokenInfo ? opts.getAppleTokenInfo // used by Native
      : getWebAppleTokenInfo; // "email" and "code" are only set if user had just failed Apple Auth

      var email = _get(state, 'identity.temp.email');

      var code = _get(state, 'identity.temp.code');

      return getAppleTokenInfo({
        usingPassword: !!password,
        email: email,
        code: code
      }).then(function (response) {
        return new Promise(function (resolve, reject) {
          return opts.IdentitySDK.loginViaApple({
            app: app || opts.identityApp,
            clientId: opts.appleSigninClientId,
            nonce: _get(response, 'nonce'),
            authorizationCode: _get(response, 'code'),
            redirectUri: _get(response, 'redirect_uri'),
            firstName: _get(response, 'user.name.firstName'),
            lastName: _get(response, 'user.name.lastName'),
            email: _get(response, 'user.email'),
            includeProfiles: opts.identityProfilesToInclude,
            profilesIfReg: mergedProfiles,
            rememberMe: rememberMe,
            password: password,
            enableHeadersAndMeta: enableHeadersAndMeta
          }).then(resolve).catch(function (err) {
            return (// Append "temp" values to payload so they can be persisted in Redux
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(_objectSpread(_objectSpread({}, err), {}, {
                temp: {
                  email: _get(response, 'user.email'),
                  code: _get(response, 'code')
                }
              }))
            );
          });
        });
      });
    }
  };
});
export var signinWithRefreshToken = createAsyncAction('signinWithRefreshToken', function (refreshToken) {
  var rememberMe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var app = arguments.length > 2 ? arguments[2] : undefined;
  var enableHeadersAndMeta = arguments.length > 3 ? arguments[3] : undefined;
  return {
    meta: {
      enableHeadersAndMeta: enableHeadersAndMeta
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.loginViaRefreshToken(app || opts.identityApp, refreshToken, opts.identityProfilesToInclude, rememberMe, enableHeadersAndMeta);
    }
  };
}); // *** Signout

export var signout = createAsyncAction('signout', function (serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.logout(serverRequest);
    }
  };
}); // *** Request identity

export var requestIdentity = createAsyncAction('requestIdentity',
/**
 * @param serverRequest {Object} - if called from the server, include the request so we can properly propagate headers
 * @param profilesToExclude {string[]} - by default, requestIdentity wholly replaces all profiles in the redux store
 * with .profiles from the AJAX response. However, the JSON response returns a `null` for all possible profiles that
 * are not requested. Use this field if you want to manage profiles outside of the requestIdentityAction, otherwise
 * the profile's value in the redux store will be set to `null` each time `requestIdentity` is invoked.
 *
 * Because we check for the member_identity_assertion_token, we'll only make this request if a user is logged in.
 */
function (serverRequest, profilesToExclude) {
  return {
    makeRequest: function () {
      var _makeRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_state, _ref4) {
        var apolloClient, identityProfilesToInclude, IdentitySDK, _yield$Promise$all, _yield$Promise$all2, identityData, financialData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apolloClient = _ref4.apolloClient, identityProfilesToInclude = _ref4.identityProfilesToInclude, IdentitySDK = _ref4.IdentitySDK;

                if (!(process.browser && !getCookie('member_identity_assertion_token'))) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Promise.reject());

              case 3:
                if (identityProfilesToInclude.includes(NwApiSDK.IDENTITY_PROFILES.YODLEE_PROFILE)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", IdentitySDK.getLoggedInIdentity(identityProfilesToInclude, serverRequest));

              case 5:
                if (apolloClient) {
                  _context.next = 8;
                  break;
                }

                logger.warn('Missing apolloClient, but requesting "yodlee_profile." Falling back to fetching from identity. This functionality may not work in the future');
                return _context.abrupt("return", IdentitySDK.getLoggedInIdentity(identityProfilesToInclude, serverRequest));

              case 8:
                _context.next = 10;
                return Promise.all([IdentitySDK.getLoggedInIdentity(identityProfilesToInclude, serverRequest), fetchFinancialData(apolloClient)]);

              case 10:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                identityData = _yield$Promise$all2[0];
                financialData = _yield$Promise$all2[1];

                _set(identityData, 'identity.profiles.yodlee_profile', transformFinancialDataProfileToLegacyDataShape(financialData));

                return _context.abrupt("return", identityData);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function makeRequest(_x, _x2) {
        return _makeRequest.apply(this, arguments);
      }

      return makeRequest;
    }(),
    meta: {
      profilesToExclude: profilesToExclude
    }
  };
});
export var resetPassword = createAsyncAction('resetPassword', function (password, resetToken, challengeAnswer, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return new Promise(function (resolve, reject) {
        return opts.IdentitySDK.resetPassword(resetToken, password, challengeAnswer, serverRequest).then(resolve).catch(function (err) {
          var message = _get(err, 'data.error.data.fields.password[0].user_message'); // If the failure is because they are trying to change their password to their old password, let's
          // just tell them it's right since they know their password needed to login.
          // returning makes the promise resolve and will dispatch success action


          if (message === 'New password must be different from old password.') {
            return resolve();
          } // otherwise throw an error so it is a failure


          reject(err);
        });
      });
    }
  };
});
export var updatePassword = createAsyncAction('updatePassword', function (oldPassword, newPassword) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.updatePassword(oldPassword, newPassword);
    }
  };
});
export var deactivateUser = createAsyncAction('deactivateUser', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.deactivate();
    }
  };
});
export var createPassword = createAsyncAction('createPassword', function (password) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.createPassword(password);
    }
  };
});
export var getSecurityQuestions = createAsyncAction('getSecurityQuestions', function (serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.getSecurityQuestions(serverRequest);
    }
  };
});
export var setSecurityQuestion = createAsyncAction('setSecurityQuestion', function (question, answer) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.setSecurityChallenge(question, answer);
    }
  };
});
export var createTUTrustSessionId = createAsyncAction('createTUTrustSessionId', function (blackBox) {
  return {
    makeRequest: function () {
      var _makeRequest2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state, _ref5) {
        var _data$createTrustSess;

        var apolloClient, _yield$apolloClient$m, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apolloClient = _ref5.apolloClient;
                _context2.next = 3;
                return apolloClient.mutate({
                  mutation: CREATE_TRUST_SESSION_ID_MUTATION,
                  variables: {
                    blackBox: blackBox
                  }
                });

              case 3:
                _yield$apolloClient$m = _context2.sent;
                data = _yield$apolloClient$m.data;
                return _context2.abrupt("return", data === null || data === void 0 ? void 0 : (_data$createTrustSess = data.createTrustSessionId) === null || _data$createTrustSess === void 0 ? void 0 : _data$createTrustSess.trustSessionId);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function makeRequest(_x3, _x4) {
        return _makeRequest2.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
export var createTUCustomer = createAsyncAction('createTUCustomer', function (customer, trustSessionId) {
  return {
    meta: {
      isFullSSN: !!customer.full_ssn
    },
    makeRequest: function () {
      var _makeRequest3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_state, _ref6) {
        var apolloClient, _yield$apolloClient$m2, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                apolloClient = _ref6.apolloClient;
                _context3.prev = 1;
                _context3.next = 4;
                return apolloClient.mutate({
                  mutation: INITIALIZE_CREDIT_PROFILE_MUTATION,
                  variables: {
                    // Existing clients are sending the customer as snake case keys
                    // but query0 is expecting camel case keys as an input
                    customer: camelcaseKeys(customer, {
                      deep: true
                    }),
                    trustSessionId: trustSessionId
                  }
                });

              case 4:
                _yield$apolloClient$m2 = _context3.sent;
                data = _yield$apolloClient$m2.data;
                return _context3.abrupt("return", mapKeysDeep(data === null || data === void 0 ? void 0 : data.initializeCreditProfile, TU_AUTHENTICATION_STATUS_PROFILE_FIELD_MAP));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                handleCreateTUCustomerError(_context3.t0, apolloClient);
                throw _context3.t0;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));

      function makeRequest(_x5, _x6) {
        return _makeRequest3.apply(this, arguments);
      }

      return makeRequest;
    }(),
    parseFail: function parseFail(resp) {
      var _resp$graphQLErrors, _parseGraphQLErrorDet2;

      var graphQLError = (_resp$graphQLErrors = resp.graphQLErrors) === null || _resp$graphQLErrors === void 0 ? void 0 : _resp$graphQLErrors[0];
      return graphQLError ? (_parseGraphQLErrorDet2 = parseGraphQLErrorDetails(graphQLError)) === null || _parseGraphQLErrorDet2 === void 0 ? void 0 : _parseGraphQLErrorDet2.responseData : resp;
    }
  };
});
export var setTUAuthentication = createAsyncAction('setTUAuthentication',
/**
 * @param {*} answers verification question answers
 * @param {*} adminUpdateWith (optional, and only used for testing purposes) a collection of mutator functions of the shape (creditReport) => newCreditReport
 * Note: supplying a value for adminUpdateWith will fail outside of testing environments where the role is not qa-crud
 * @param {boolean} useDualResponseMutation if set to true, will utilize the new query0 mutation that correctly returns a response that can be two types.
 * @returns Either a TU Credit Report Profile or a TU Authentication Status Profile
 */
function (answers, adminUpdateWith) {
  var useDualResponseMutation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    makeRequest: function () {
      var _makeRequest4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref7, opts) {
        var identity, apolloClient, IdentitySDK, _yield$apolloClient$m3, data, profileResponse, isCreditReport, authenticationResponse, creditReport;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                identity = _ref7.identity;
                apolloClient = opts.apolloClient, IdentitySDK = opts.IdentitySDK;
                _context4.next = 4;
                return apolloClient.mutate({
                  mutation: useDualResponseMutation ? AUTHENTICATE_CREDIT_PROFILE_QUESTIONS_MUTATION : AUTHENTICATE_CREDIT_PROFILE_MUTATION,
                  variables: {
                    // Existing clients are sending answers as snake case keys
                    // but query0 is expecting camel case keys as an input
                    answers: camelcaseKeys(answers)
                  }
                });

              case 4:
                _yield$apolloClient$m3 = _context4.sent;
                data = _yield$apolloClient$m3.data;
                profileResponse = useDualResponseMutation ? data === null || data === void 0 ? void 0 : data.authenticateCreditProfileQuestions : data === null || data === void 0 ? void 0 : data.authenticateCreditProfile;
                isCreditReport = !!(profileResponse !== null && profileResponse !== void 0 && profileResponse.currentAddress); // snakecaseKeys does not handle numbers well so manually mapping the fields

                authenticationResponse = mapKeysDeep(profileResponse, useDualResponseMutation === false || isCreditReport ? TU_CREDIT_REPORT_PROFILE_FIELD_MAP : TU_AUTHENTICATION_STATUS_PROFILE_FIELD_MAP); // Overwrite credit report with test data only if a Credit Report type has been returned

                if (!(isCreditReport && adminUpdateWith !== null && adminUpdateWith !== void 0 && adminUpdateWith.length)) {
                  _context4.next = 14;
                  break;
                }

                creditReport = adminUpdateWith.reduce(function (_creditReport, update) {
                  return update(_creditReport);
                }, authenticationResponse);
                _context4.next = 13;
                return updateIdentityProfile({
                  data: creditReport,
                  profileType: IdentitySDK.PROFILES.TU_CREDIT_REPORT_PROFILE
                }, {
                  identity: identity,
                  opts: opts
                }, true);

              case 13:
                authenticationResponse = _context4.sent;

              case 14:
                return _context4.abrupt("return", authenticationResponse);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function makeRequest(_x7, _x8) {
        return _makeRequest4.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
export var enrollTUCustomer = createAsyncAction('enrollTUCustomer', function () {
  return {
    makeRequest: function () {
      var _makeRequest5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_state, _ref8) {
        var apolloClient, _yield$apolloClient$m4, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                apolloClient = _ref8.apolloClient;
                _context5.prev = 1;
                _context5.next = 4;
                return apolloClient.mutate({
                  mutation: ENROLL_CREDIT_PROFILE_MUTATION
                });

              case 4:
                _yield$apolloClient$m4 = _context5.sent;
                data = _yield$apolloClient$m4.data;
                return _context5.abrupt("return", mapKeysDeep(data === null || data === void 0 ? void 0 : data.enrollCreditProfile, TU_CREDIT_REPORT_PROFILE_FIELD_MAP));

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](1);
                apolloClient.writeQuery({
                  query: TU_ENROLL_FAILED_QUERY,
                  data: {
                    _tuEnrollFailed: true
                  }
                });
                throw _context5.t0;

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 9]]);
      }));

      function makeRequest(_x9, _x10) {
        return _makeRequest5.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
export var refreshTUCreditProfile = createAsyncAction('refreshTUCreditProfile', function (shouldPurge) {
  return {
    meta: {
      shouldPurge: shouldPurge
    },
    makeRequest: function () {
      var _makeRequest6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_state, _ref9) {
        var apolloClient, _yield$apolloClient$m5, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                apolloClient = _ref9.apolloClient;
                _context6.next = 3;
                return apolloClient.mutate({
                  mutation: REFRESH_CREDIT_PROFILE_MUTATION
                });

              case 3:
                _yield$apolloClient$m5 = _context6.sent;
                data = _yield$apolloClient$m5.data;
                return _context6.abrupt("return", mapKeysDeep(data === null || data === void 0 ? void 0 : data.refreshCreditProfile, TU_CREDIT_REPORT_PROFILE_FIELD_MAP));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function makeRequest(_x11, _x12) {
        return _makeRequest6.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
export var deactivateTUCustomer = createAsyncAction('deactivateTUCustomer', function () {
  return {
    makeRequest: function () {
      var _makeRequest7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_state, _ref10) {
        var apolloClient, _yield$apolloClient$m6, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                apolloClient = _ref10.apolloClient;
                _context7.next = 3;
                return apolloClient.mutate({
                  mutation: DEACTIVATE_CREDIT_PROFILE_MUTATION
                });

              case 3:
                _yield$apolloClient$m6 = _context7.sent;
                data = _yield$apolloClient$m6.data;
                return _context7.abrupt("return", mapKeysDeep(data === null || data === void 0 ? void 0 : data.deactivateCreditProfile, TU_AUTHENTICATION_STATUS_PROFILE_FIELD_MAP));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function makeRequest(_x13, _x14) {
        return _makeRequest7.apply(this, arguments);
      }

      return makeRequest;
    }()
  };
});
export var deactivateUserViaToken = createAsyncAction('deactivateUserViaToken', function (deactivateToken) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.deactivateViaToken(deactivateToken);
    }
  };
});
export var lookupSecurityChallenge = createAsyncAction('lookupSecurityChallenge', function (token, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.lookupSecurityChallenge(token, serverRequest);
    }
  };
});
export var requestOtpSecret = createAsyncAction('requestOtpSecret', function (password, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.requestOtpSecret(password, serverRequest);
    }
  };
});
export var deactivateOtp = createAsyncAction('deactivateOtp', function (otpCode, serverRequest) {
  return {
    meta: {
      otpCode: otpCode
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.deactivateOtp(otpCode, serverRequest);
    }
  };
});
export var verifyOtpCode = createAsyncAction('verifyOtpCode', function (otpCode, serverRequest) {
  return {
    meta: {
      otpCode: otpCode
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.verifyOtpCode(otpCode, serverRequest);
    }
  };
});
export var generateOtpBackupCodes = createAsyncAction('generateOtpBackupCodes', function (otpCode, serverRequest) {
  return {
    meta: {
      otpCode: otpCode
    },
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.generateOtpBackupCodes(otpCode, serverRequest);
    }
  };
});
export var acknowledgeTOS = createAsyncAction('acknowledgeTOS', function (type, source, version, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.acknowledgeTOS(type, source, version, serverRequest);
    },
    meta: {
      tosEntry: {
        type: type,
        source: source,
        version: version
      }
    }
  };
});
export var restartTUFlow = createAction('restartTUFlow');
export var saveRegisterImpression = createAction('saveRegisterImpression');